// Querys and Mutations
import {
    ALL_ACTIVE_ONLY_NAME,
    GET_WITH_PAGINATION,
    CREATE,
    UPDATE,
    DELETE,
    CHANGE_STATUS
} from '@/graphql/config/WorkShiftGraphql'

// models
import { Paginator, ResponseDefault } from '@/models'
import { WorkShiftModel, WorkShiftForm, WorkShiftsWithPagination } from '@/models/config'

// apollo
import { apolloClient } from '@/apollo'

class WorkShiftService {
    async getActivated (): Promise<WorkShiftModel[]> {
        const result = await apolloClient.query({
            query: ALL_ACTIVE_ONLY_NAME
        })
        return result.data.workShiftsActive
    }

    async getWithPagination (perPage = 10, page = 1): Promise<WorkShiftsWithPagination> {
        const result = await apolloClient.query({
            query: GET_WITH_PAGINATION,
            variables: {
                page: page,
                perPage: perPage
            }
        })
        const pagination: Paginator = result.data.workShiftsWithPagination.paginatorInfo
        const data: [WorkShiftModel] = result.data.workShiftsWithPagination.data
        const response: WorkShiftsWithPagination = {
            objects: data,
            pagination: pagination
        }
        return response
    }

    /**
     * Mutations
     */
     async create (form: WorkShiftForm): Promise<WorkShiftModel> {
        const result = await apolloClient.mutate({
            mutation: CREATE,
            variables: {
                input: form
            }
        })
        return result.data.createWorkShift
    }

    async update (id: number, form: WorkShiftForm): Promise<WorkShiftModel> {
        const result = await apolloClient.mutate({
            mutation: UPDATE,
            variables: {
                id: id,
                input: form
            }
        })
        return result.data.updateWorkShift
    }

    async changeStatus (id: number, status: boolean): Promise<ResponseDefault> {
        await apolloClient.mutate({
            mutation: CHANGE_STATUS,
            variables: {
                id: id,
                input: {
                    is_active: status
                }
            }
        })
        return {
            success: true,
            errors: []
        }
    }

    async delete (id: number): Promise<ResponseDefault> {
        await apolloClient.mutate({
            mutation: DELETE,
            variables: {
                id: id
            }
        })
        return {
            success: true,
            errors: []
        }
    }
}

export default new WorkShiftService()
